import React from "react";
import PropTypes from "prop-types";
import safeHtml from "web/core/utils/safeHtml";
import classNames from "classnames";

const Heading = (defaultComponent, displayName) => {
  const HeadingComponent = ({
    children,
    itemProp,
    as: asComponent,
    className,
    noStyles,
  }) => {
    const Component = asComponent || defaultComponent;

    const classes = classNames(
      {
        [defaultComponent]: !noStyles,
      },
      "heading",
      className
    );

    return typeof children === "string" ? (
      <Component
        className={classes}
        dangerouslySetInnerHTML={{ __html: safeHtml(children) }}
        itemProp={itemProp}
      />
    ) : (
      <Component className={classes} itemProp={itemProp}>
        {children}
      </Component>
    );
  };

  HeadingComponent.displayName = displayName;

  HeadingComponent.propTypes = {
    children: PropTypes.node.isRequired,
    itemProp: PropTypes.string,
    as: PropTypes.string,
    className: PropTypes.string,
  };

  return HeadingComponent;
};

export default Heading;
